<template>
  <div class="app-container">
    <el-row :gutter="10" class="mb8">
      <el-col :span="1.5">
        <el-button type="primary" @click="handleAdd">添加公告</el-button>
      </el-col>
    </el-row>
    <el-table v-loading="loading" :data="dataList">
      <el-table-column label="公告ID" min-width="150" align="center" prop="content" />
      <el-table-column label="公告标题" min-width="100" align="center" prop="statusDesc" />
      <el-table-column label="创建时间" min-width="170" align="center" prop="createTime" />
      <el-table-column label="状态" min-width="100" align="center" prop="updateTime" />
      <el-table-column label="操作" min-width="130" align="center">
        <template slot-scope="scope">
          <el-button type="text" @click="handleSee(scope.row)">查看</el-button>
          <el-button type="text" @click="handleOffline(scope.row)">下线</el-button>
          <el-button type="text" @click="handleOnline(scope.row)">上线</el-button>
          <el-button type="text" @click="handleDelete(scope.row)">删除</el-button>
          <el-button type="text" @click="handleEdit(scope.row)">编辑</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      v-show="total>0"
      :total="total"
      :page.sync="queryParams.pageNum"
      :limit.sync="queryParams.pageSize"
      @pagination="getList"
    />
    <AddNotice ref="addNoticeDialog" @success="getList"></AddNotice>
  </div>
</template>

<script>
import { queryBusinessByTargetId } from "@/api/crm/business";
import AddNotice from "../components/addNoticeDialog";
import { amountFormat } from "@/utils/index";

export default {
  name: "BusinessList",
  components: {
    amountFormat
  },
  props: {
    customerId: {},
    contactId: {},
    height: {
      type: String,
      default() {
        return "250";
      }
    }
  },
  data() {
    return {
      total: 30,
      loading: false,
      queryParams: {
        pageNum: 1,
        pageSize: 10
      },
      dataList: [
        {
          content: "一体化设备",
          statusDesc: '已上线',
          updateTime: "2021.03.01 12:12:12"
        }
      ]
    };
  },
  created() {
    if (this.customerId || this.contactId) {
      this.queryList();
    }
  },
  methods: {
    handleAdd() {
      this.$refs.addNoticeDialog.open();
    },
    getList(e) {
        console.log('ee---', e)
    },
    queryList() {
      this.loading = true;
      queryBusinessByTargetId({
        customerId: this.customerId,
        contactId: this.contactId
      })
        .then(response => {
          this.dataList = response.data || [];
          this.$emit("after-query", this.dataList);
          this.loading = false;
        })
        .catch(error => {
          this.loading = false;
        });
    }
  }
};
</script>
